import ProdutoTable from './ProdutoTable';

export default ProdutoTable;
